import dynamic from 'next/dynamic'

export const DynamicStudentPurchaseModal = dynamic(
  () => import('.').then((mod) => mod.StudentPurchaseModal),
  { ssr: false },
)
